// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import configs from '../configs';
import { IntegrationLayout, CredentialsSetup, ExternalLinkA } from '../_shared';
import DripCampaigns from './DripCampaigns';

class OMI366 extends Component {
  state = { active: 'setup' };

  componentDidMount() {
    this.props.store.integrations.OMI366.getConfigs();
    this.props.store.integrations.OMI366.getDripCampaigns();
  }

  render() {
    return (
      <IntegrationLayout
        config={configs.OMI366}
        tabs={[
          { value: 'setup', label: 'Setup' },
          { value: 'drip', label: 'Drip Campaigns' },
        ]}
        active={this.state.active}
        onTab={(v) => this.setState({ active: v })}
      >
        {this.state.active === 'setup' ? (
          <CredentialsSetup
            partnerKey="OMI366"
            steps={[
              <>Make an account with 366 <ExternalLinkA href="https://366.io/SignUp?Partner=Mov052">here</ExternalLinkA>.</>,
              <>Go to your <ExternalLinkA href="https://366.io/CompanyProfile/CompanyProfile">Company Profile page</ExternalLinkA> to find the App Key and App Secret.</>,
              'Paste them below and click Update.',
              'Future captures will be created as contacts on 366.',
            ]}
            fields={[
              { name: 'appKey', label: 'App Key' },
              { name: 'appSecret', label: 'App Secret' },
            ]}
          />
        ) : <DripCampaigns />}
      </IntegrationLayout>
    );
  }
}

export default inject('store')(observer(OMI366));
